/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_Not_Synced_HintInputs */

const cs_auth_meta_not_synced_hint = /** @type {(inputs: Auth_Meta_Not_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Meta pro tento e-mail ještě není nastavené. Přihlaste se níže heslem, pak v Nastavení profilu → Meta → Propojit.`)
};

const en_auth_meta_not_synced_hint = /** @type {(inputs: Auth_Meta_Not_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta sign-in is not set up for this email yet. Sign in with your password below, then open Profile settings → Meta → Connect.`)
};

/**
* | output |
* | --- |
* | "Meta sign-in is not set up for this email yet. Sign in with your password below, then open Profile settings → Meta → Connect." |
*
* @param {Auth_Meta_Not_Synced_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_not_synced_hint = /** @type {((inputs?: Auth_Meta_Not_Synced_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_Not_Synced_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_not_synced_hint(inputs)
	return cs_auth_meta_not_synced_hint(inputs)
});